/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forCart } from "./constants";
import { apiUrl_forOrders } from "./constants";

const CancelToken = axios.CancelToken;

export let cancelGetOrdersApi;
export async function getOders(token, query = "") {
    if (token) {
        const orders = await axios.get(apiUrl_forOrders + "?" + query, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrdersApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelAddCartApi;
export async function createOrder(token, orderData) {
    if ((token, orderData)) {
        const order = await axios.post(
            apiUrl_forCart + "create/order",
            orderData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCartApi = c;
                }),
            }
        );
        return order;
    } else {
        console.log("Please add required parameters");
    }
}

// get order details
export let cancelGetOrderDetailsApi;
export async function getOrderDetails(token, orderId) {
    if (token && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders + `detail/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderDetailsApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// get order notes
export let cancelGetOrderNotesApi;
export async function getOrderNotes(token, orderId) {
    if (token && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders + `notes/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// add order notes
export let cancelAddOrderNotesApi;
export async function addOrderNotes(token, { orderId, notes }) {
    if (token && orderId && notes) {
        const ordersData = await axios.post(
            apiUrl_forOrders + `notes/${orderId}`,
            { notes },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// update order notes
export let cancelUpdateOrderNotesApi;
export async function updateOrderNotes(token, { orderId, notes }) {
    if (token && orderId && notes) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `notes/${orderId}`,
            { notes },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// add order notes
export let cancelDeleteOrderNotesApi;
export async function deleteOrderNotes(token, { orderId, noteId }) {
    if (token && orderId && noteId) {
        const ordersData = await axios.delete(
            apiUrl_forOrders + `notes/${orderId}/${noteId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteOrderNotesApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// order status list
export let cancelGetOrderStatusListApi;
export async function getOrderStatusList(token) {
    if (token) {
        const orders = await axios.get(apiUrl_forOrders + "statuses", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrderStatusListApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

// order status list
export let cancelGetOrderPaymentStatusListApi;
export async function getOrderPaymentStatusList(token) {
    if (token) {
        const orders = await axios.get(apiUrl_forOrders + "payment/statuses", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrderPaymentStatusListApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

// update order status
export let cancelUpdateOrderStatusApi;
export async function updateOrderStatus(
    token,
    { orderId, statusCode, trackingNumber }
) {
    if (token && orderId && statusCode) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `status/${orderId}`,
            {
                status_code: statusCode,
                tracking_number: trackingNumber,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdateOrderStatusApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// update order status
export let cancelUpdatePaymentStatusApi;
export async function updatePaymentStatus(token, { orderId, statusCode }) {
    if (token && orderId && statusCode) {
        const ordersData = await axios.put(
            apiUrl_forOrders + `payment/status/${orderId}`,
            { status_code: statusCode },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelUpdatePaymentStatusApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}
